"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormData = require('form-data');
class CustomerBusinessRepositoryImpl {
    fetcherAmplify;
    fetcherAxios;
    constructor(fetcherAmplify, fetcherAxios) {
        this.fetcherAmplify = fetcherAmplify;
        this.fetcherAxios = fetcherAxios;
    }
    async saveFile(url, fields, file) {
        const formData = new FormData();
        const keys = [
            'Content-Type',
            'key',
            'bucket',
            'X-Amz-Algorithm',
            'X-Amz-Credential',
            'X-Amz-Date',
            'X-Amz-Security-Token',
            'Policy',
            'X-Amz-Signature',
        ];
        keys.forEach((name) => {
            formData.append(name, fields[name]);
        });
        formData.append('file', file);
        return this.fetcherAxios.post(url, formData);
    }
    async createRepresentative(customerId, data, attachments) {
        const response = await this.fetcherAmplify.post(`/v1/customers/${customerId}/details`, {
            body: data,
        });
        const filesToUpload = [];
        if (response.attachments?.documentoContacto?.upload &&
            attachments?.documentoContacto) {
            const { url, fields } = response.attachments?.documentoContacto?.upload;
            filesToUpload.push(() => this.saveFile(url, fields, attachments.documentoContacto));
        }
        await Promise.all(filesToUpload.map((f) => f()));
        return response;
    }
    async getCustomerBusinessDetails(customerId, types) {
        const response = await Promise.all(types.map((type) => this.fetcherAmplify.get(`/v1/customers/${customerId}/details/?type=${type}`, {
            queryStringParameters: {
                fullData: true,
            },
        })));
        return response.flatMap((r) => r);
    }
    async updateRepresentative(customerId, data, attachments) {
        const response = await this.fetcherAmplify.put(`/v1/customers/${customerId}/details/${data?.id}`, { body: data });
        const filesToUpload = [];
        if (response.attachments?.documentoContacto?.upload &&
            attachments?.documentoContacto) {
            const { url, fields } = response.attachments?.documentoContacto?.upload;
            filesToUpload.push(() => this.saveFile(url, fields, attachments.documentoContacto));
        }
        await Promise.all(filesToUpload.map((f) => f()));
        return response;
    }
    async deleteRepresentative(customerId, representativeId) {
        await this.fetcherAmplify.delete(`/v1/customers/${customerId}/details/${representativeId}`);
    }
}
exports.default = CustomerBusinessRepositoryImpl;
//# sourceMappingURL=CustomerBusinessRepositoryImpl.js.map